<script>
    export let short = false;
    export let ajankohtaistaUrl = "2025-06-20_juhannus";
    let title = "Hyvää juhannusta Dynamosalilta!";
    let titlePic = "/svelte-site/img/ajankohtaista/maija_hieroo.jpg";
    let firstPara = "Maija valmistui hierojaksi! Onnea Maija! | Kesän ryhmätreenien aikataulut.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
    <div class="blogSummary">
        <a href="/ajankohtaista/{ajankohtaistaUrl}">
            <span class="articleImage"
                  style="background-image: url('{titlePic}"></span>
            <span>
            <span class="blogTitle">{title}</span>
            <span class="blogShortContent">{firstPara}</span>
        </span>
        </a>
    </div>

{:else}
    <div class="blog page">
        <article class="container">
            <div class="row">
                <div class="col-xs-12 col-md-8">
                    <h1>{title}</h1>
                    <b>Valmistuin hierojaksi – jatkan palveluja Dynamosalin tiloissa!</b><br>
                    <p>Hierontaopintoni ovat tulleet päätökseen, ja valmistuin koulutetuksi hierojaksi 13.6.2025. Jatkan edelleen hierojana Dynamosalin tiloissa. Hierontahuoneeni löytyy salin yläkerrasta. </p>
                    <b>Tarjoan asiakkailleni klassista hierontaa. Kiinnostukseni on erityisesti urheilijoiden hieronnassa ja palautumisessa. Käytän hieronnassani myös mobilisoivia tekniikoita.</b><br>
                    <p>Jokainen asiakas on minulle tärkeä, ja hieron jokaisen asiakkaan hänen omien tarpeidensa mukaan.</p>
                    <p>Varaa tästä itsellesi hieronta-aika sähköisestä <a target="_blank" href="https://booksalon.fi/hyvinvointipalvelut-maija-karvonen"> kalenterista </a>
                        tai puhelimitse 050 3806463.</p>
                    <p>Dynamosalin jäsenille hieronnoista -10%. Varauksen yhteydessä kirjoita kommenttikenttään ”Dynamosali”. </p>
                    <img src="/svelte-site/img/ajankohtaista/maija_hinnasto.png"/>
                    <p>Hierontatyön lisäksi järjestän myös juoksukouluja sekä teen juoksuohjauksia. Seuraavat Dynamosalin yhteiset, maksuttomat yhteisjuoksutreenit ovat:</p>
                    <p>Sunnuntaina 29.6. Kempeleen Köykkyrissä klo 18:00, aiheena suojuoksu (Kari) <br>
                        Sunnuntaina 6.7. Köykkyrissä klo 18:00, juoksutekniikka ja pyramidiharjoitus (Maija)</p>
                    <p>Tervetuloa mukaan!<br>
                        Terveisin <br>
                        koulutettu hieroja, liikuntaneuvoja Maija Karvonen<br>
                    </p>
                    <b>Ryhmätreenien kesäaikataulu 31.7. asti</b><br>
                    <p>Muistutuksena vielä, että maanantain yhteistreenit jäävät tauolle heinäkuun loppuun asti.<br>

                        Tiistai: Savotta klo 18<br>
                        Torstai: Kaski klo 18<br>
                        Lauantai: Pihasavotta klo 11<br></p>

                    <p>Kesäaikataulut päivittyvät nettisivuillemme ja voit aina tarkistaa voimassaolevat treeniajat osoitteesta https://www.dynamosali.com/treenit-aukioloajat.
                    </p>
                    <p>
                        Aurinkoista kesää!<br>
                        Dynamosalin koutsit<br>
                    </p>


                </div>
                <div class="col-xs-12 col-md-4">
                    <img src="/svelte-site/img/ajankohtaista/maija.jpg"/>
                </div>
            </div>
        </article>
    </div>
{/if}
